import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import FlightTabs from "../AllTabs/FlightTabs";

const initialEditState = {
  groupBookingRequestId: "00000000-0000-0000-0000-000000000000",
  status: "",
};

const statusOptions = [
  "Pending",
  "In Progress",
  "Confirmed",
  "Quote Sent",
  "Rejected",
  "Cancelled",
];

const GroupBookings = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialEditState);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [editShow, setEditShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [viewShow, setViewShow] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [selectedRecordDetails, setSelectedRecordDetails] = useState(null);
  const handleViewClose = () => {
    setViewShow(false);
    setSelectedRecordDetails(null);
  };

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleEditClose = () => {
    setEditShow(false);
    setRecordForEdit(null);
    setValues(initialEditState);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        groupBookingRequestId: recordForEdit.groupBookingRequestId,
        status: recordForEdit.status,
      });
    }
  }, [recordForEdit]);

  const GetData = async (currentPage) => {
    setLoading(true);
    try {
      const res = await apiService.get(
        `${config.GETADMINBOOKING}/${user.cid}`,
        pageSize,
        currentPage
      );
      setLists(res.data);
      setPageNumber(res.pageNumber);
      setPageSize(res.pageSize);
      setTotalPages(res.totalPages);
      setTotalRecords(res.totalRecords);
    } catch (error) {
      console.error("Failed to fetch booking requests", error);
      setLists([]);
    } finally {
      setLoading(false);
    }
  };

  const GetLastPageData = () => GetData(totalPages);
  const GetFirstPageData = () => GetData(1);
  const GetPageData = (number) => {
    if (pageNumber !== number) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setEditShow(true);
  };
  const handleViewDetails = async (requestId) => {
    setViewShow(true);
    setDetailsLoading(true);
    try {
      const response = await apiService.getById(
        config.GETBOOKINGBYID,
        requestId
      );
      setSelectedRecordDetails(response);
    } catch (error) {
      handleViewClose();
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEBOOKINGREQUEST, itemToDelete);
        // const newPageNumber = lists.length === 1 && pageNumber > 1 ? pageNumber - 1 : pageNumber;
        await GetData(pageNumber);
      } catch (error) {
        // Error is handled by apiService
      }
      handleCloseDeleteModal();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);

    const updatePayload = {
      requestId: values.groupBookingRequestId,
      newStatus: values.status,
    };

    try {
      await apiService.update(config.UPDATEBOOKINGREQUEST, updatePayload);
      await GetData(pageNumber);
      resetForm();
    } catch (error) {
    } finally {
      setBtnLoading(false);
    }
  };

  const resetForm = () => {
    setValues(initialEditState);
    setEditShow(false);
    setBtnLoading(false);
    setRecordForEdit(null);
  };

  useEffect(() => {
    if (user && !authLoading) {
      GetData(pageNumber);
    }
  }, [user, authLoading, pageNumber]);

  if (authLoading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} activeSection="flights" /> 
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <FlightTabs pageName="GROUPFLIGHT" />
                </div>
                <div className="card-body">
                  {loading ? (
                    <div className="text-center p-5">
                      <div className="spinner-border text-primary" />
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive table-card p-2">
                        <table
                          className="table align-middle"
                          id="customerTable"
                        >
                          <thead className="bg-soft-success bg-gradient">
                            <tr>
                              <th>S.No</th>
                              <th>Agent</th>
                              <th>Itinerary</th>
                              <th>Journey Type</th>
                              <th>Travellers</th>
                              <th>Status</th>
                              <th>Requested On</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody className="list form-check-all">
                            {lists.length > 0 ? (
                              lists.map((v, index) => (
                                <tr key={v.groupBookingRequestId}>
                                  <td>{index + 1}</td>
                                  <td>{v.agentCompanyName}</td>
                                  <td>
                                    <span className="fw-medium">
                                      {v.primaryFrom}
                                    </span>{" "}
                                    to{" "}
                                    <span className="fw-medium">
                                      {v.primaryTo}
                                    </span>
                                  </td>
                                  <td>{v.journeyType}</td>
                                  <td>{v.totalTravellers}</td>
                                  <td>
                                    <span className="badge bg-primary-subtle text-primary">
                                      {v.status}
                                    </span>
                                  </td>
                                  <td>
                                    {new Date(
                                      v.createdDate
                                    ).toLocaleDateString()}
                                  </td>
                                  <td>
                                    <ul className="list-inline hstack gap-2 mb-0">
                                      <li
                                        className="list-inline-item"
                                        title="View"
                                      >
                                        <Link
                                          to="#"
                                          className="view-item-btn"
                                          onClick={() =>
                                            handleViewDetails(
                                              v.groupBookingRequestId
                                            )
                                          }
                                        >
                                          <i className="ri-eye-fill align-bottom text-muted" />
                                        </Link>
                                      </li>
                                      <li
                                        className="list-inline-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-trigger="hover"
                                        data-bs-placement="top"
                                        title="Edit"
                                      >
                                        <Link
                                          to="#"
                                          className="edit-item-btn"
                                          onClick={() => showEditDetails(v)}
                                        >
                                          <i className="ri-pencil-fill align-bottom text-muted" />
                                        </Link>
                                      </li>
                                      <li
                                        className="list-inline-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-trigger="hover"
                                        data-bs-placement="top"
                                        title="Delete"
                                      >
                                        <Link
                                          to="#"
                                          className="remove-item-btn"
                                          onClick={() =>
                                            handleOpenDeleteModal(
                                              v.groupBookingRequestId
                                            )
                                          }
                                        >
                                          <i className="ri-delete-bin-fill align-bottom text-muted" />
                                        </Link>
                                      </li>
                                    </ul>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No booking requests found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                        <div className="flex-shrink-0">
                          <div className="text-muted">
                            Showing{" "}
                            <span className="fw-semibold">{lists.length}</span>{" "}
                            of{" "}
                            <span className="fw-semibold">{totalRecords}</span>{" "}
                            Results
                          </div>
                        </div>
                        <ul className="pagination pagination-separated pagination-sm mb-0">
                          <li
                            className={`page-item ${
                              pageNumber === 1 ? "disabled" : ""
                            }`}
                          >
                            <Link
                              to="#"
                              className="page-link"
                              onClick={GetFirstPageData}
                            >
                              First
                            </Link>
                          </li>
                          {renderPageNumbers}
                          <li
                            className={`page-item ${
                              pageNumber >= totalPages ? "disabled" : ""
                            }`}
                          >
                            <Link
                              to="#"
                              className="page-link"
                              onClick={GetLastPageData}
                            >
                              Last
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={editShow} onHide={handleEditClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Request Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} noValidate>
              <div className="mb-3">
                <label htmlFor="status-select" className="form-label">
                  Status
                </label>
                <select
                  id="status-select"
                  className="form-select"
                  name="status"
                  value={values.status}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    -- Select a status --
                  </option>
                  {statusOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <Modal.Footer className="px-0 pb-0">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={resetForm}
                >
                  Cancel
                </button>
                {btnLoading ? (
                  <button type="button" className="btn btn-primary" disabled>
                    <span
                      className="spinner-border spinner-border-sm me-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Updating...
                  </button>
                ) : (
                  <button type="submit" className="btn btn-primary">
                    Update Status
                  </button>
                )}
              </Modal.Footer>
            </form>
          </Modal.Body>
        </Modal>
        <Modal show={viewShow} onHide={handleViewClose} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Booking Request Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {detailsLoading ? (
              <div className="text-center p-5">
                <div className="spinner-border text-primary" />
              </div>
            ) : selectedRecordDetails ? (
              <div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h6 className="text-muted">Agent</h6>
                    <p>{selectedRecordDetails.agentCompanyName}</p>
                  </div>
                  <div className="col-md-6">
                    <h6 className="text-muted">Status</h6>
                    <p>
                      <span className="badge bg-primary fs-6">
                        {selectedRecordDetails.status}
                      </span>
                    </p>
                  </div>
                </div>
                <hr />
                <h5 className="mb-3">Itinerary</h5>
                {selectedRecordDetails.segments.map((seg, index) => (
                  <div key={index} className="d-flex align-items-center mb-2">
                    <div className="flex-shrink-0">
                      <i className="ri-flight-takeoff-line fs-5 text-primary"></i>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="mb-0 fw-medium">
                        {seg.from} to {seg.to}
                      </p>
                      <small className="text-muted">
                        {new Date(seg.departureDate).toLocaleDateString(
                          "en-GB",
                          { day: "numeric", month: "long", year: "numeric" }
                        )}
                      </small>
                    </div>
                  </div>
                ))}
                <hr />
                <h5 className="mb-3">Travellers</h5>
                <div className="row">
                  <div className="col-4">
                    <p>
                      <strong>Adults:</strong> {selectedRecordDetails.adults}
                    </p>
                  </div>
                  <div className="col-4">
                    <p>
                      <strong>Kids:</strong> {selectedRecordDetails.kids}
                    </p>
                  </div>
                  <div className="col-4">
                    <p>
                      <strong>Infants:</strong> {selectedRecordDetails.infants}
                    </p>
                  </div>
                </div>
                <hr />
                <h5 className="mb-3">Additional Info</h5>
                <p>
                  <strong>Preferred Airlines:</strong>{" "}
                  {selectedRecordDetails.preferredAirlines || "Not specified"}
                </p>
                <p>
                  <strong>Agent Comments:</strong>
                </p>
                <p className="p-2 bg-light rounded">
                  {selectedRecordDetails.comments || "No comments provided."}
                </p>
                <hr />
                <div className="d-flex justify-content-between text-muted small">
                  <span>
                    Requested On:{" "}
                    {new Date(
                      selectedRecordDetails.createdDate
                    ).toLocaleString()}
                  </span>
                  {selectedRecordDetails.updatedDate && (
                    <span>
                      Last Updated:{" "}
                      {new Date(
                        selectedRecordDetails.updatedDate
                      ).toLocaleString()}
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <p className="text-center text-danger">Could not load details.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-light"
              onClick={handleViewClose}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default GroupBookings;
